import { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import useMediaQueryHook from "@hooks/useMediaQueryHook";
import Sidebar from "@components/ui/Sidebar/index";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import { useUserData } from "context/OAuth/AuthContext";
import { Contact, Search } from "lucide-react";
import { toast } from "react-toastify";
import { useTranslation } from "react-i18next";
import { updateLanguage } from "api/generalServices";
import { useSelector } from "react-redux";
import { useUI } from "context/LoadingContext";
const WORDPRESS_BASE_URL = process.env.REACT_APP_WORDPRESS_URL;

const Navbar = ({ medicalModal = false }) => {
  const { user, showCreatePlan, handleSetLanguage, medicalView } = useUserData();
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { isMobile, isTablet } = useMediaQueryHook();
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [hover, setHover] = useState(false);
  const { isActionLocked } = useUI();

  const [isLoading, setIsLoading] = useState(false);
  const dropdownRefs = useRef({});
  const { t } = useTranslation();
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        dropdownRefs.current &&
        !dropdownRefs.current.contains(event.target)
      ) {
        setDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const toggleDrawer = (open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setDrawerOpen(open);
  };

  const handleCategoryChange = async (lang) => {
    setIsLoading(true);
    try {
      await updateLanguage(lang);
      handleSetLanguage(lang);

      toast.info(
        t("languageChangeSuccess", {
          lang: lang == "nl" ? "Nederlands" : "English",
        })
      );
    } catch (error) {
      toast.error("Failed to update language. Please try again later.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <nav className="bg-white px-6 py-3 flex items-center justify-between max-w-[100vw] lg:max-w-unset">
        {!(isMobile || isTablet) && (
          <>
            {/* <div className="text-lg font-medium text-[#0575E6E5] ml-5">
              Hi, {user?.name}
            </div> */}

            {medicalModal ? (
              <Link to="/">
                <img
                  src="/logo.png"
                  alt="logo"
                  className="w-[164px] object-cover mx-auto"
                />
              </Link>
            ) : (
              <div className="flex justify-center items-center w-80">
                {/* <div className="relative w-96">
              <span className="absolute inset-y-0 left-0 flex items-center pl-3">
                <Search className="w-4 h-4 text-gray-400" />
              </span>
              <input
                type="text"
                placeholder="Search Anything"
                className="w-full pl-10 pr-4 py-2 border border-[#afb3be] rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div> */}
              </div>
            )}
          </>
        )}
        <div
          className={`relative ${
            (isMobile || isTablet) &&
            "w-[100%] flex justify-between items-center"
          } `}
        >
          {(isMobile || isTablet) && (
            <>
              <button
                className="px-3 py-0 rounded-[50%]  bg-[linear-gradient(150deg,_#0771EF_12.89%,_#15AAFC_85.22%)] h-[45px]"
                onClick={() => setDrawerOpen(!drawerOpen)}
              >
                <span className="block w-6 h-0.5 bg-white mb-1"></span>
                <span className="block w-6 h-0.5 bg-white my-1"></span>
                <span className="block w-6 h-0.5 bg-white mt-1"></span>
              </button>
              <Link to="/">
                <img
                  src="/logo.png"
                  alt="logo"
                  className="w-[164px] object-cover mx-auto"
                />
              </Link>
            </>
          )}
          <div
            className={`flex items-center space-x-2 ${
              (isMobile || isTablet) && "float-right"
            }`}
          >
            {/* <div className="hidden lg:flex items-center space-x-2 bg-gray-50 p-1 rounded-full">
              {["en", "nl"].map((lang) => {
                const isActive = language === lang;
                const isLoadingCurrent = isLoading && isActive;

                return (
                  <button
                    key={lang}
                    onClick={() => !isActive && handleCategoryChange(lang)}
                    disabled={isLoadingCurrent || isActionLocked}
                    onMouseOver={() =>
                      (isLoadingCurrent || isActionLocked) && setHover(true)
                    }
                    onMouseLeave={() =>
                      (isLoadingCurrent || isActionLocked) && setHover(false)
                    }
                    className={`
          relative flex items-center justify-center px-4 py-2 text-sm rounded-full 
          transition-all duration-300 min-w-[135px]
          border border-transparent
          ${
            isActive
              ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-sm"
              : "bg-white text-gray-700 hover:bg-gray-100"
          }
          ${
            isLoadingCurrent || isActionLocked
              ? "opacity-80 cursor-wait"
              : "cursor-pointer"
          }
        `}
                  >
                    <span className="flex items-center justify-center gap-2">
                      {isLoadingCurrent ? (
                        <svg
                          className="animate-spin h-4 w-4 text-current"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                          ></path>
                        </svg>
                      ) : (
                        <img
                          src={lang === "en" ? "/uk.svg" : "/nl.svg"}
                          alt={lang}
                          className="w-5 h-5 object-contain rounded-full"
                        />
                      )}
                      {lang === "en" ? "English" : "Nederlands"}
                    </span>
                  </button>
                );
              })}
            </div> */}

            <svg
              width="34"
              height="3 4"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12.4051 21.05C13.428 21.05 14.2564 20.2215 14.2564 19.1987H10.5538C10.5538 20.2215 11.3823 21.05 12.4051 21.05ZM17.959 15.4962V10.8679C17.959 8.0216 16.4456 5.64733 13.7936 5.0179V4.38846C13.7936 3.62018 13.1734 3 12.4051 3C11.6368 3 11.0167 3.62018 11.0167 4.38846V5.0179C8.36471 5.64733 6.85128 8.0216 6.85128 10.8679V15.4962L5 17.3474V18.2731H19.8103V17.3474L17.959 15.4962Z"
                fill="#9B9FAB"
              />
              <circle cx="17" cy="7" r="3" fill="white" />
              <circle cx="17" cy="7" r="2" fill="#FF3D3D" />
            </svg>
            <div className="relative" ref={dropdownRefs}>
              <button
                className="flex items-center space-x-2 focus:outline-none"
                onClick={() => setDropdownOpen(!dropdownOpen)}
              >
                <img
                  src={user?.profile_picture_url ?? "/image.png"}
                  alt="User"
                  className="w-10 h-10 rounded-full object-cover"
                />{" "}
                {!(isMobile || isTablet) && (
                  <span className="ml-2 flex items-center">
                    {user?.name}
                    {dropdownOpen ? (
                      <svg
                        className="ml-2"
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.41944 7.37079L13.0694 1.71079C13.1632 1.61783 13.2376 1.50723 13.2883 1.38537C13.3391 1.26351 13.3652 1.1328 13.3652 1.00079C13.3652 0.868781 13.3391 0.738075 13.2883 0.616216C13.2376 0.494356 13.1632 0.383755 13.0694 0.290792C12.8821 0.104542 12.6286 -3.21984e-08 12.3644 -4.37463e-08C12.1003 -5.52942e-08 11.8468 0.104541 11.6594 0.290792L6.65944 5.24079L1.70944 0.290792C1.52207 0.104541 1.26862 -5.2876e-07 1.00444 -5.40308e-07C0.740251 -5.51856e-07 0.486799 0.104541 0.299437 0.290792C0.204948 0.383407 0.129778 0.493852 0.0782814 0.615727C0.0267849 0.737602 -1.33894e-05 0.868485 -0.000562712 1.00079C-1.3401e-05 1.1331 0.0267848 1.26398 0.0782813 1.38586C0.129778 1.50773 0.204948 1.61818 0.299436 1.71079L5.94944 7.37079C6.04308 7.4723 6.15673 7.55331 6.28323 7.60871C6.40973 7.66412 6.54633 7.69272 6.68444 7.69272C6.82254 7.69272 6.95914 7.66412 7.08564 7.60871C7.21214 7.55331 7.32579 7.4723 7.41944 7.37079Z"
                          fill="#0575E6"
                        />
                      </svg>
                    ) : (
                      <svg
                        className="ml-2"
                        width="14"
                        height="8"
                        viewBox="0 0 14 8"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.41944 7.37079L13.0694 1.71079C13.1632 1.61783 13.2376 1.50723 13.2883 1.38537C13.3391 1.26351 13.3652 1.1328 13.3652 1.00079C13.3652 0.868781 13.3391 0.738075 13.2883 0.616216C13.2376 0.494356 13.1632 0.383755 13.0694 0.290792C12.8821 0.104542 12.6286 -3.21984e-08 12.3644 -4.37463e-08C12.1003 -5.52942e-08 11.8468 0.104541 11.6594 0.290792L6.65944 5.24079L1.70944 0.290792C1.52207 0.104541 1.26862 -5.2876e-07 1.00444 -5.40308e-07C0.740251 -5.51856e-07 0.486799 0.104541 0.299437 0.290792C0.204948 0.383407 0.129778 0.493852 0.0782814 0.615727C0.0267849 0.737602 -1.33894e-05 0.868485 -0.000562712 1.00079C-1.3401e-05 1.1331 0.0267848 1.26398 0.0782813 1.38586C0.129778 1.50773 0.204948 1.61818 0.299436 1.71079L5.94944 7.37079C6.04308 7.4723 6.15673 7.55331 6.28323 7.60871C6.40973 7.66412 6.54633 7.69272 6.68444 7.69272C6.82254 7.69272 6.95914 7.66412 7.08564 7.60871C7.21214 7.55331 7.32579 7.4723 7.41944 7.37079Z"
                          fill="#0575E6"
                        />
                      </svg>
                    )}
                  </span>
                )}
              </button>
              {dropdownOpen && (
                <div
                  className={`absolute right-0 ${
                    (isMobile || isTablet) && "top-9"
                  } mt-2 w-56 bg-[#fff] border rounded shadow-lg z-[2]`}
                >
                  <ul className="py-2">
                    {/* <li className="px-4 py-2 hover:bg-[#F6F7FB] cursor-pointer">
                      <Link
                        to={`${WORDPRESS_BASE_URL}/my-account/edit-account/`}
                      >
                        <span className="flex items-center">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M13.3327 14V12.6667C13.3327 11.9594 13.0517 11.2811 12.5516 10.781C12.0515 10.281 11.3733 10 10.666 10H5.33268C4.62544 10 3.94716 10.281 3.44706 10.781C2.94697 11.2811 2.66602 11.9594 2.66602 12.6667V14M10.666 4.66667C10.666 6.13943 9.47211 7.33333 7.99935 7.33333C6.52659 7.33333 5.33268 6.13943 5.33268 4.66667C5.33268 3.19391 6.52659 2 7.99935 2C9.47211 2 10.666 3.19391 10.666 4.66667Z"
                              stroke="#45464B"
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                          <p
                            className="ml-2"
                            onClick={() => {
                              setDropdownOpen(false);
                            }}
                          >
                            {t("navbar.viewProfile")}
                          </p>
                        </span>
                      </Link>
                    </li> */}
                    <li>
                      {" "}
                      {/* <div className="flex lg:hidden flex-col items-center gap-2 bg-gray-50 rounded-md mx-2 px-2 py-2 shadow-md border border-grey-200">
                        {["en", "nl"].map((lang) => {
                          const isActive = language === lang;
                          const isLoadingCurrent = isLoading && isActive;

                          return (
                            <button
                              key={lang}
                              onClick={(e) => {
                                e.stopPropagation();
                                !isActive && handleCategoryChange(lang);
                              }}
                              disabled={isLoadingCurrent}
                              className={`
          relative flex items-center justify-center px-4 py-2 text-sm rounded-full 
          transition-all duration-300 w-full
          
          ${
            isActive
              ? "bg-gradient-to-r from-blue-600 to-blue-500 text-white shadow-sm"
              : "bg-white text-gray-700 hover:bg-gray-100 border border-[2px] border-grey-200"
          }
          ${isLoadingCurrent ? "opacity-80 cursor-wait" : "cursor-pointer"}
        `}
                            >
                              <span className="flex items-center justify-center gap-2">
                                {isLoadingCurrent ? (
                                  <svg
                                    className="animate-spin h-4 w-4 text-current"
                                    viewBox="0 0 24 24"
                                  >
                                    <circle
                                      className="opacity-25"
                                      cx="12"
                                      cy="12"
                                      r="10"
                                      stroke="currentColor"
                                      strokeWidth="4"
                                    ></circle>
                                    <path
                                      className="opacity-75"
                                      fill="currentColor"
                                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                    ></path>
                                  </svg>
                                ) : (
                                  <img
                                    src={lang === "en" ? "/uk.svg" : "/nl.svg"}
                                    alt={lang}
                                    className="w-5 h-5 object-contain rounded-full"
                                  />
                                )}
                                {lang === "en" ? "English" : "Nederlands"}
                              </span>
                            </button>
                          );
                        })}
                      </div> */}
                    </li>
                    <li className="px-4 py-2 hover:bg-[#F6F7FB] cursor-pointer">
                      <Link
                        to={`${WORDPRESS_BASE_URL}/my-account/edit-account/`}
                      >
                        <span className="flex items-center">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M7.99935 9.99984C9.10392 9.99984 9.99935 9.10441 9.99935 7.99984C9.99935 6.89527 9.10392 5.99984 7.99935 5.99984C6.89478 5.99984 5.99935 6.89527 5.99935 7.99984C5.99935 9.10441 6.89478 9.99984 7.99935 9.99984Z"
                              stroke="#45464B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                            <path
                              d="M12.9327 9.99984C12.8439 10.2009 12.8175 10.424 12.8567 10.6402C12.8959 10.8565 12.999 11.0561 13.1527 11.2132L13.1927 11.2532C13.3167 11.377 13.415 11.5241 13.4821 11.6859C13.5492 11.8478 13.5837 12.0213 13.5837 12.1965C13.5837 12.3717 13.5492 12.5452 13.4821 12.7071C13.415 12.869 13.3167 13.016 13.1927 13.1398C13.0689 13.2638 12.9218 13.3622 12.7599 13.4292C12.5981 13.4963 12.4246 13.5309 12.2493 13.5309C12.0741 13.5309 11.9006 13.4963 11.7388 13.4292C11.5769 13.3622 11.4298 13.2638 11.306 13.1398L11.266 13.0998C11.1089 12.9461 10.9093 12.843 10.6931 12.8038C10.4768 12.7646 10.2538 12.7911 10.0527 12.8798C9.8555 12.9643 9.68734 13.1047 9.56889 13.2835C9.45044 13.4624 9.38687 13.672 9.38602 13.8865V13.9998C9.38602 14.3535 9.24554 14.6926 8.99549 14.9426C8.74544 15.1927 8.4063 15.3332 8.05268 15.3332C7.69906 15.3332 7.35992 15.1927 7.10987 14.9426C6.85982 14.6926 6.71935 14.3535 6.71935 13.9998V13.9398C6.71419 13.7192 6.64276 13.5052 6.51436 13.3256C6.38595 13.1461 6.20651 13.0094 5.99935 12.9332C5.79827 12.8444 5.57522 12.818 5.35896 12.8572C5.14269 12.8964 4.94313 12.9995 4.78602 13.1532L4.74602 13.1932C4.62218 13.3171 4.47513 13.4155 4.31327 13.4826C4.1514 13.5497 3.9779 13.5842 3.80268 13.5842C3.62746 13.5842 3.45396 13.5497 3.2921 13.4826C3.13023 13.4155 2.98318 13.3171 2.85935 13.1932C2.73538 13.0693 2.63703 12.9223 2.56994 12.7604C2.50284 12.5986 2.4683 12.4251 2.4683 12.2498C2.4683 12.0746 2.50284 11.9011 2.56994 11.7392C2.63703 11.5774 2.73538 11.4303 2.85935 11.3065L2.89935 11.2665C3.05304 11.1094 3.15614 10.9098 3.19535 10.6936C3.23456 10.4773 3.20809 10.2542 3.11935 10.0532C3.03484 9.85599 2.89452 9.68783 2.71566 9.56937C2.5368 9.45092 2.32721 9.38736 2.11268 9.3865H1.99935C1.64573 9.3865 1.30659 9.24603 1.05654 8.99598C0.806491 8.74593 0.666016 8.40679 0.666016 8.05317C0.666016 7.69955 0.806491 7.36041 1.05654 7.11036C1.30659 6.86031 1.64573 6.71984 1.99935 6.71984H2.05935C2.28001 6.71468 2.49402 6.64325 2.67355 6.51484C2.85308 6.38644 2.98983 6.20699 3.06602 5.99984C3.15476 5.79876 3.18123 5.57571 3.14202 5.35944C3.10281 5.14318 2.99971 4.94362 2.84602 4.7865L2.80602 4.7465C2.68205 4.62267 2.5837 4.47562 2.5166 4.31376C2.4495 4.15189 2.41497 3.97839 2.41497 3.80317C2.41497 3.62795 2.4495 3.45445 2.5166 3.29258C2.5837 3.13072 2.68205 2.98367 2.80602 2.85984C2.92985 2.73587 3.0769 2.63752 3.23876 2.57042C3.40063 2.50333 3.57413 2.46879 3.74935 2.46879C3.92457 2.46879 4.09807 2.50333 4.25994 2.57042C4.4218 2.63752 4.56885 2.73587 4.69268 2.85984L4.73268 2.89984C4.8898 3.05353 5.08936 3.15663 5.30562 3.19584C5.52189 3.23505 5.74494 3.20858 5.94602 3.11984H5.99935C6.19653 3.03533 6.36469 2.89501 6.48314 2.71615C6.60159 2.53729 6.66516 2.32769 6.66602 2.11317V1.99984C6.66602 1.64622 6.80649 1.30708 7.05654 1.05703C7.30659 0.80698 7.64573 0.666504 7.99935 0.666504C8.35297 0.666504 8.69211 0.80698 8.94216 1.05703C9.19221 1.30708 9.33268 1.64622 9.33268 1.99984V2.05984C9.33354 2.27436 9.3971 2.48395 9.51555 2.66281C9.634 2.84167 9.80217 2.982 9.99935 3.0665C10.2004 3.15525 10.4235 3.18172 10.6397 3.14251C10.856 3.10329 11.0556 3.00019 11.2127 2.8465L11.2527 2.8065C11.3765 2.68254 11.5236 2.58419 11.6854 2.51709C11.8473 2.44999 12.0208 2.41545 12.196 2.41545C12.3712 2.41545 12.5447 2.44999 12.7066 2.51709C12.8685 2.58419 13.0155 2.68254 13.1393 2.8065C13.2633 2.93033 13.3617 3.07739 13.4288 3.23925C13.4959 3.40111 13.5304 3.57462 13.5304 3.74984C13.5304 3.92506 13.4959 4.09856 13.4288 4.26042C13.3617 4.42229 13.2633 4.56934 13.1393 4.69317L13.0993 4.73317C12.9457 4.89029 12.8426 5.08985 12.8033 5.30611C12.7641 5.52237 12.7906 5.74543 12.8793 5.9465V5.99984C12.9639 6.19702 13.1042 6.36518 13.283 6.48363C13.4619 6.60208 13.6715 6.66565 13.886 6.6665H13.9993C14.353 6.6665 14.6921 6.80698 14.9422 7.05703C15.1922 7.30708 15.3327 7.64621 15.3327 7.99984C15.3327 8.35346 15.1922 8.6926 14.9422 8.94265C14.6921 9.19269 14.353 9.33317 13.9993 9.33317H13.9393C13.7248 9.33403 13.5152 9.39759 13.3364 9.51604C13.1575 9.63449 13.0172 9.80266 12.9327 9.99984Z"
                              stroke="#45464B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span
                            className="ml-2"
                            onClick={() => {
                              setDropdownOpen(false);
                            }}
                          >
                            {t("navbar.myAccount")}
                          </span>
                        </span>
                      </Link>
                    </li>
                    {!medicalView && !showCreatePlan && (
                      <li className="px-4 py-2 hover:bg-[#F6F7FB] cursor-pointer">
                        <Link to="#">
                          <span className="flex items-center">
                            <svg
                              width="16"
                              height="14"
                              viewBox="0 0 16 14"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M10.666 13V11.6667C10.666 10.9594 10.3851 10.2811 9.88497 9.78105C9.38487 9.28095 8.70659 9 7.99935 9H3.33268C2.62544 9 1.94716 9.28095 1.44706 9.78105C0.946967 10.2811 0.666016 10.9594 0.666016 11.6667V13M13.3327 4.33333V8.33333M15.3327 6.33333H11.3327M8.33268 3.66667C8.33268 5.13943 7.13877 6.33333 5.66602 6.33333C4.19326 6.33333 2.99935 5.13943 2.99935 3.66667C2.99935 2.19391 4.19326 1 5.66602 1C7.13877 1 8.33268 2.19391 8.33268 3.66667Z"
                                stroke="#45464B"
                                stroke-width="1.5"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                            <Link
                              className="ml-2"
                              onClick={() => {
                                setDropdownOpen(false);
                              }}
                              to={"/invite-member"}
                            >
                              {t("navbar.inviteMember")}
                            </Link>
                          </span>
                        </Link>
                      </li>
                    )}
                    <li className="px-4 py-2 hover:bg-[#F6F7FB] cursor-pointer">
                      <Link to={`/contact-us`}>
                        <span className="flex items-center">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6.06065 6.00016C6.21739 5.55461 6.52675 5.1789 6.93395 4.93958C7.34116 4.70027 7.81991 4.61279 8.28544 4.69264C8.75096 4.77249 9.1732 5.01451 9.47737 5.37585C9.78154 5.73718 9.94802 6.19451 9.94732 6.66683C9.94732 8.00016 7.94732 8.66683 7.94732 8.66683M8.00065 11.3335H8.00732M14.6673 8.00016C14.6673 11.6821 11.6826 14.6668 8.00065 14.6668C4.31875 14.6668 1.33398 11.6821 1.33398 8.00016C1.33398 4.31826 4.31875 1.3335 8.00065 1.3335C11.6826 1.3335 14.6673 4.31826 14.6673 8.00016Z"
                              stroke="#45464B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span
                            className="ml-2"
                            onClick={() => setDropdownOpen(false)}
                          >
                            {t("navbar.support")}
                          </span>
                        </span>
                      </Link>
                    </li>
                    <li className="px-4 py-2 hover:bg-[#F6F7FB] cursor-pointer text-red-600">
                      <Link to={"/logout"}>
                        <span className="flex items-center">
                          <svg
                            width="16"
                            height="16"
                            viewBox="0 0 16 16"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M6 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H6M10.6667 11.3333L14 8M14 8L10.6667 4.66667M14 8H6"
                              stroke="#45464B"
                              stroke-width="1.5"
                              stroke-linecap="round"
                              stroke-linejoin="round"
                            />
                          </svg>
                          <span className="ml-2">{t("navbar.logout")}</span>
                        </span>
                      </Link>
                    </li>
                  </ul>
                </div>
              )}
            </div>
          </div>
        </div>
      </nav>
      <SwipeableDrawer
        anchor="left"
        open={drawerOpen}
        onClose={toggleDrawer(false)}
        onOpen={toggleDrawer(true)}
      >
        {(isMobile || isTablet) && (
          <Sidebar smallScreen={true} setDrawerOpen={setDrawerOpen} />
        )}
      </SwipeableDrawer>
    </>
  );
};

export default Navbar;
